/* <soh-carousel>: native scroll-snap track [data-track]; arrows [data-prev]/[data-next]; dots [data-dots] generated. Touch swipe = native scroll. */
class SohCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]'); this.slides = [...this.track.children];
    const step = () => (this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth);
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
    const dots = this.querySelector('[data-dots]');
    if (dots) {
      dots.innerHTML = this.slides.map((_, i) => '<button type="button" class="soh-carousel__dot" aria-label="Go to slide ' + (i + 1) + '"></button>').join('');
      this.dotEls = [...dots.children];
      this.dotEls.forEach((d, i) => d.addEventListener('click', () => this.track.scrollTo({ left: this.slides[i].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' })));
      this.track.addEventListener('scroll', () => { const i = Math.round(this.track.scrollLeft / step()); this.dotEls.forEach((d, j) => d.setAttribute('aria-current', String(i === j))); }, { passive: true });
      this.dotEls[0]?.setAttribute('aria-current', 'true');
    }
  }
}
customElements.define('soh-carousel', SohCarousel);
